import { H7 } from 'foundations-components/transitional/components/H7';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Box } from 'foundations-components/transitional/components/Box';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { OwnersProvider } from '../../context/OwnersContext';
import ApprovalUnifiedEventsList from './ApprovalUnifiedEventsList';
import useUnifiedEvents from '../../hooks/useUnifiedEvents';
import ErrorBoundary from '../error/ErrorBoundary';
import { getTranslatedApprovalType } from '../../utils/translationUtils';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function DottedLine(props) {
  return /*#__PURE__*/_jsx(View, Object.assign({}, props, {
    borderBlockStartStyle: "dashed",
    borderBlockStartWidth: "100",
    borderBlockStartColor: "border-core-subtle",
    inlineSize: "100%"
  }));
}
function SectionTitle(props) {
  const {
    index
  } = props;
  if (index > 1) {
    return null;
  }
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    marginBlockEnd: "300",
    children: [/*#__PURE__*/_jsx(Box, {
      grow: 1,
      shrink: 0,
      marginInlineEnd: "300",
      children: /*#__PURE__*/_jsxs(H7, {
        marginBlockEnd: "0",
        children: [index === 0 && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalUnifiedEvents.currentApproval"
        }), index === 1 && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalUnifiedEvents.previousApprovals"
        })]
      })
    }), /*#__PURE__*/_jsx(DottedLine, {})]
  });
}
export default function ApprovalUnifiedEvents() {
  const {
    approvalEventsGrouped,
    hasLoadedData,
    isLoading,
    approvalType
  } = useUnifiedEvents();
  const assetType = getTranslatedApprovalType(approvalType);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(OwnersProvider, {
      children: isLoading || !hasLoadedData ? /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        size: "small",
        layout: "centered"
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(View, {
          marginBlockEnd: "300",
          as: "div",
          children: /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "productApprovals.ApprovalUnifiedEvents.description",
              options: {
                assetType
              }
            })
          })
        }), approvalEventsGrouped.map((events, index) => /*#__PURE__*/_jsxs(TFlex, {
          direction: "column",
          align: "stretch",
          children: [/*#__PURE__*/_jsx(SectionTitle, {
            index: index
          }), /*#__PURE__*/_jsx(ApprovalUnifiedEventsList, {
            events: events
          }), index > 0 && index + 1 < approvalEventsGrouped.length && /*#__PURE__*/_jsx(DottedLine, {})]
        }, index))]
      })
    })
  });
}